<template>
  <div class="img-box">
    <img src="https://oss.aqdpay.com/appweb/activeimg/tunnelNotice/bg.png" alt="">
    <div class="btn">
        <img src="https://oss.aqdpay.com/appweb/activeimg/tunnelNotice/btn.png" alt="" @click="goApp">
    </div>
  </div>
</template>
<script>
export default {
  data () {},
  methods: {
    goApp () {
      window.location.href = 'bjqd://'
      setTimeout(function () {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
      }, 1200)
    }
  }
}
</script>
<style lang="scss" scoped>
.img-box {
  min-height: 100vh;
  background: #ffc904;
  img {
    width: 100%;
  }
  .btn {
      padding: 20px;
      img {
          width: 100%;
      }
  }
}
</style>
